module.exports = __webpack_public_path__ + "static/luggage-3c695ac521b6541110e5e62729ee2c36.png";